const initialState = {
  item: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "GET_COMMON_DATA_REQUEST":
      return {
        ...state,
        item: action.item,
      };
    case "GET_STOCK_LIST_SUCCESS":
      return {
        ...state,
        stockData: action.data.items || [],
        loading: false,
      };
    case "SET_TRANSACTION_CONFIG_DATA":
      return {
        ...state,
        transactionData:action.data
      }
    default:
      return state;
  }
}
